import React from 'react';
import { ClockIcon, PhoneIcon, ShieldCheckIcon } from 'lucide-react';
import { StarRating } from './StarRating';
import { useLanguage } from '../contexts/LanguageContext';
import { business, images } from '../data/business';
import { ui } from '../data/ui';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section id="top" className="relative isolate flex min-h-[600px] items-center overflow-hidden md:min-h-[680px]" aria-labelledby="page-title" data-id="element-193" data-mp="4n1ov1j4iux9">
      <img src={images.hero} alt={t(ui.hero.imageAlt)} className="absolute inset-0 -z-20 h-full w-full object-cover object-[60%_center]" data-id="element-194" data-mp="xae6qyecaek8" />
      <div className="absolute inset-0 -z-10 bg-[rgba(30,58,138,0.3)]" aria-hidden="true" data-id="element-195" data-mp="sa9szg4tfxxp" />

      <div className="container-page py-20 text-center [text-shadow:0_2px_18px_rgba(10,18,45,0.55)]" data-id="element-196" data-mp="nb6k1klpt7kg">
        <div className="mx-auto max-w-4xl" data-id="element-197" data-mp="3d2l9jc5qb50p">
          <h1 id="page-title" className="font-display text-4xl font-extrabold leading-[1.1] tracking-tight text-white md:text-5xl lg:text-[56px]" data-id="element-198" data-mp="3cz5to748dry8">
            {t(ui.hero.title)}
          </h1>
          <p className="mt-5 font-display text-lg font-semibold text-leaf-light md:text-xl" data-id="element-199" data-mp="3j6fwnlhhz5bq">{t(ui.hero.subtitle)}</p>
          <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-white md:text-lg" data-id="element-200" data-mp="39acyeqprnqu2">{t(ui.hero.description)}</p>

          <div className="mt-9 flex flex-col items-stretch justify-center gap-3 [text-shadow:none] sm:flex-row sm:items-center" data-id="element-201" data-mp="3e8wi0kgw0qj9">
            <a href="#contact" className="btn btn-green whitespace-nowrap px-8 text-[15px]" data-id="element-202" data-mp="30h9ebzkm8fqg">
              {t(ui.requestEstimate)}
            </a>
            <a href={business.phoneHref} className="btn btn-outline-white whitespace-nowrap px-8 text-[15px]" data-id="element-203" data-mp="2qjvaczfvpjf1">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-204" data-mp="2viev4wiqkp5t" />
              {t(ui.call)} {business.phoneShort}
            </a>
          </div>

          <ul className="mt-10 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm text-white" data-id="element-205" data-mp="2hjoxnfs08ngx">
            <li className="flex items-center gap-2" data-id="element-206" data-mp="2lmv16fnqg0jp">
              <StarRating data-id="element-207" data-mp="s2b7vyavsj55" />
              <span data-id="element-208" data-mp="s3mavvwi5mv7">
                <strong className="font-semibold" data-id="element-209" data-mp="s44i1nkpdlhw">{business.rating.toFixed(1)}</strong> {t(ui.onGoogle)}
              </span>
            </li>
            <li className="flex items-center gap-2" data-id="element-210" data-mp="ibowkga76es9">
              <ShieldCheckIcon className="h-4 w-4 text-leaf-light" aria-hidden="true" data-id="element-211" data-mp="ia5j0xfxehu6" />
              {t(ui.licensed)}
            </li>
            <li className="flex items-center gap-2" data-id="element-212" data-mp="1b0nmw0oh4n8n">
              <ClockIcon className="h-4 w-4 text-leaf-light" aria-hidden="true" data-id="element-213" data-mp="1b04b71pf2v32" />
              {t(ui.hoursShort)}
            </li>
          </ul>
        </div>
      </div>
    </section>;
}